document.addEventListener('DOMContentLoaded', function () {
  const formWrapper = document.querySelector('[data-block-type="buy-buttons"]');
  if (!formWrapper) return;

  const form = formWrapper.querySelector('form[action^="/cart/add"]');
  if (!form) return;

  const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
  const variantIdInput = form.querySelector('input[name="id"]');
  const sellingPlanPropertyInput = form.querySelector('input[name="properties[_Selling plan ID]"]');
  
  if (!sellingPlanInput || !variantIdInput || !sellingPlanPropertyInput) return;

  const updateCheckedStates = () => {
    const radios = form.querySelectorAll('input[type="radio"][data-radio-type="selling_plan"], input[type="radio"][data-radio-type="one_time_purchase"]');

    radios.forEach(radio => {
      if (radio.checked) {
        radio.setAttribute('checked', '');
        radio.closest('label')?.classList.add('pk-product-selling-plan__allocation-label--selected');
      } else {
        radio.removeAttribute('checked');
        radio.closest('label')?.classList.remove('pk-product-selling-plan__allocation-label--selected');
      }
    });
  };

  const updateSellingPlanValue = () => {
    const selectedPlan = form.querySelector('input[type="radio"][data-radio-type="selling_plan"]:checked');
    const oneTime = form.querySelector('input[type="radio"][data-radio-type="one_time_purchase"]:checked');

    if (selectedPlan) {
      const planId = selectedPlan.dataset.sellingPlanId || '';
      sellingPlanInput.value = planId;
      sellingPlanPropertyInput.value = planId;
    }

    if (oneTime) {
      sellingPlanInput.value = '';
      sellingPlanPropertyInput.value = '';
    }
  };

  updateSellingPlanValue();
  updateCheckedStates();

  form.addEventListener('change', function () {
    updateSellingPlanValue();
    updateCheckedStates();
  });

  form.addEventListener('submit', function () {
    updateSellingPlanValue();
  });
});
